import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('benefits_set_csv_export', '/benefits_set_csv_exports')
const actions = generator.generate()

export default actions
